<app-breadcrumbs title="{{ id ? 'BADGES.EDIT_TITLE' : 'BADGES.CREATE_TITLE' }}" [first]="'MENU.ADMINISTRATION.BADGES'" [url]="'/badges'" [id]="breadcrumbsId"></app-breadcrumbs>

<div class="btn-container">
    <dx-button *ngIf="((authorities.create && id == null) || (authorities.update && id != null))" class="ml-2 navbar-button" [height]="32" stylingMode="contained" icon="save" [disabled]="!pendingChanges" [text]="'SHARED.SAVE_CHANGES' | translate" type="success" (onClick)="saveChanges($event)"></dx-button>
</div>

<div class="row">
    <div class="col-12 col-xxl-4">
        <dx-form #form class="form-vertical" [formData]="formData" [showColonAfterLabel]="false" (onFieldDataChanged)="fieldDataChanged($event)">
            <dxi-item dataField="mnemonic" editorType="dxTextBox" [editorOptions]="{ valueChangeEvent: 'keyup', maxLength: 3, readOnly: !((authorities.create && id == null) || (authorities.update && id != null)) }">
                <dxo-label location="left" alignment="left" [text]="'SHARED.CODE' | translate"></dxo-label>
                <dxi-validation-rule type="required" [message]="'VALIDATION.REQUIRED' | translate"></dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="name" editorType="dxTextBox" [editorOptions]="{ valueChangeEvent: 'keyup', maxLength: 30, readOnly: !((authorities.create && id == null) || (authorities.update && id != null)) }">
                <dxo-label location="left" alignment="left" [text]="'SHARED.NAME' | translate"></dxo-label>
                <dxi-validation-rule type="required" [message]="'VALIDATION.REQUIRED' | translate"></dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="searchable" editorType="dxCheckBox" width="80px" [editorOptions]="{ value: false }">
                <dxo-label location="left" alignment="left" [text]="'PRODUCTS.PRODUCT_ATTRIBUTE_SEARCHABLE' | translate"></dxo-label>
            </dxi-item>
            <dxi-item *ngIf="id != null" dataField="image.path" editorType="dxTextBox" [editorOptions]="{ valueChangeEvent: 'keyup', maxLength: 40, readOnly: true }">
                <dxo-label location="left" alignment="left" [text]="'SHARED.IMAGE' | translate"></dxo-label>
            </dxi-item>
        </dx-form>

        <dx-tooltip showEvent="mouseenter" [hideEvent]="{ name: 'mouseout', delay: 2000 }" target="label[for*='searchable']">
            <div *dxTemplate="let data of 'content'">
                {{ 'PRODUCTS.PRODUCT_ATTRIBUTE_SEARCHABLE_HINT' | translate }} 
            </div>
        </dx-tooltip>
    </div>
    <div class="col-12 col-xxl-8">
        <dx-tab-panel class="form-panel" [dataSource]="tabs" [selectedIndex]="0" [loop]="false" [animationEnabled]="true" [swipeEnabled]="true">
            <div *dxTemplate="let tab of 'title'">
                <span>{{'SHARED.' + tab | translate}}</span>
            </div>
    
            <div class="form-vertical" *dxTemplate="let tab of 'item'">
                <div *ngIf="tab == 'IMAGES'">
                    <app-files *ngIf="formData" [canUpload]="true" [canDelete]="true" [disabled]="isFileUploadDisabled()" [code]="formData.mnemonic" [type]="'BADGE'" [images]="[formData.image]" [single]="true" (uploadFinishedEvent)="uploadFinishedEvent($event)" (deletedEvent)="deletedEvent($event)"></app-files>
                </div>
            </div>
        </dx-tab-panel>
    </div>
</div>